module.exports = __webpack_public_path__ + "img/26.8e3ce9cc.jpg";